import React, { PureComponent } from 'react'
import activityTrackingService from '../../../../services/activityTrackingService'
import PropTypes from 'prop-types'
import Select from '../../Form/Select'

/**
 * SelectTracked tracks changes in the select value and triggers a trackEvent
 */
class SelectTracked extends PureComponent {

  onChange = (e) => {
    const { onChange, eventName, eventOpts } = this.props
    activityTrackingService.trackEvent(eventName, eventOpts)
    onChange && onChange(e)
  }

  render () {
    const parentProps = { ...this.props }
    delete parentProps.eventName
    delete parentProps.eventOpts
    return (
      <Select {...parentProps} onChange={this.onChange}/>
    )
  }
}

SelectTracked.defaultProps = Select.defaultProps
SelectTracked.propTypes = {
  ...Select.propTypes,
  eventName: PropTypes.string.isRequired,
  eventOpts: PropTypes.object.isRequired
}
export default SelectTracked
